export default __webpack_public_path__ + "static/lets@2x-f91f7ed72be4a375c8ede4ceaea7623a.png";